import React, { useState } from 'react';
import './../../entrydoor.css';

const Brickmould = ({ value, onChange, label = 'Brickmould:', childs = [], childs1 = [] }) => { // Set default value for childs
    const [selectedBrickmould, setSelectedBrickmould] = useState(value || "None");

    const visibleShapes = ["Loose", "Installed"];
    const visibleShapes1 = ["Installed"];

    const handleBrickmouldChange = (e) => {
        const newValue = e.target.value;
        setSelectedBrickmould(newValue);
        onChange(e.target.value);

        // Dynamically fetch and modify styles for dependent controls if any exist
        if (Array.isArray(childs) && childs.length > 0) {
            childs.forEach((childId) => {
                const element = document.getElementById(childId);
                if (element) {
                    element.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                    const label = element.previousElementSibling; // Fetch the label, if present
                    if (label) {
                        label.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                    }
                }
            });
        }

        if (Array.isArray(childs1) && childs1.length > 0) {
            childs1.forEach((childId) => {
                const element = document.getElementById(childId);
                if (element) {
                    element.style.display = visibleShapes1.includes(newValue) ? "block" : "none";
                    const label = element.previousElementSibling; // Fetch the label, if present
                    if (label) {
                        label.style.display = visibleShapes1.includes(newValue) ? "block" : "none";
                    }
                }
            });
        }
        if (newValue  === "Installed") {
        }
    };

    return (
        <div className="a-container">
            <label htmlFor="Brickmould">{label}</label>
            <select
                id="Brickmould"
                value={selectedBrickmould}
                onChange={handleBrickmouldChange}
            >
              <option value="None">{selectedBrickmould === "None" ? "None ✔" : "None"}</option>
              <option value="Loose">{selectedBrickmould === "Loose" ? "Loose ✔" : "Loose"}</option>
              <option value="Installed">{selectedBrickmould === "Installed" ? "Installed ✔" : "Installed"}</option>
            </select>
        </div>
    );
};

export default Brickmould;
